import { render, staticRenderFns } from "./UkrTreasuresModule.vue?vue&type=template&id=17c961ca"
import script from "./UkrTreasuresModule.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports